module.exports = __webpack_public_path__ + "static/media/22.43ceef48.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/shirts/22.png
// module id = 1461
// module chunks = 0